<div class="notification">
    <p *ngIf="!isArabic">{{message}}</p>
    <p *ngIf="!isArabic">{{messageOne}}</p>
    <p *ngIf="isArabic">{{arabicMessage}}</p>
</div>
<div class="mb-5 okayBtn">
    <button type="submit" class="btn btn-primary cancelBtn" (click)="closeNotification()" *ngIf="cancelButton">
        <span *ngIf="!isArabic">CANCEL</span>
        <span *ngIf="isArabic">إلغاء</span>
    </button>
    <button type="submit" class="btn btn-primary" (click)="closeNotification(true)">
        <span *ngIf="!isArabic">OK</span>
        <span *ngIf="isArabic">نعم</span>
    </button>
</div>

